import HttpClient from "../services/HttpClient";
import {
  APP_URL,
  REQUISITIONSAVE,
  REQUISITIONFINISH,
  REQUISITION,
  REQUISITIONSEARCH,
  REQUISITIONREJECT,
  ERROR_MESSAGE,
  REQUISITIONSEARCH_USER_CHARGE,
  REQUISITIONSEARCH_ALL,
} from "../constants";

export const saveRequisition = (requisition, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${REQUISITIONSAVE}`, requisition, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const finishRequisition = (requisition, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${REQUISITIONFINISH}`, requisition, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const anularRequisicionConfirm = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${REQUISITIONFINISH}`, id, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const rechazarRequisicionConfirm = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${REQUISITIONREJECT}`, id, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getRequisitions = (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${REQUISITION}`, headers)
      .then((response) => {
        if (response.data.result) {
          resolve(response);
        }
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getRequisitionById = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${REQUISITION}${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getFilterRequisitions = (filters, paginator, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${REQUISITIONSEARCH}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};

export const getFilterRequisitionsUserCharge = (
  filters,
  paginator,
  dispatch
) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${REQUISITIONSEARCH_USER_CHARGE}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        //reject(error.response);
        resolve(error.response);
      });
  });
};

export const getFilterAllRequisitions = (
  filters,
  paginator,
  dispatch
) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(
      `${APP_URL}${REQUISITIONSEARCH_ALL}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
      filters,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.response?.data
              ? error?.response?.data?.detail
              : ERROR_MESSAGE,
          },
        });
        //reject(error.response);
        resolve(error.response);
      });
  });
};

//  **  Manejo de Estados **
// Cancelada
// Rechazada
// Publicada
// Cerrada
// Aprobada

export const updateRequisitionStatus = (data, dispatch, url) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}${url}`, data, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getRequisitionObservationsById = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL}${REQUISITION}${id}/trace`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
        resolve(error.response);
      });
  });
};